import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 29 29",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      d: "M24.469 7.75c.222 0 .406.184.406.406V24.47a4.037 4.037 0 0 1-4.031 4.031H8.156a4.037 4.037 0 0 1-4.031-4.031V8.156c0-.223.183-.406.406-.406.224 0 .407.183.407.406V24.47a3.22 3.22 0 0 0 3.218 3.218h12.688a3.222 3.222 0 0 0 3.218-3.218V8.156c0-.222.184-.406.407-.406ZM9.062 10.469c.225 0 .407.181.407.406v12.688a.406.406 0 1 1-.813 0V10.874c0-.223.183-.406.406-.406Zm5.438 0c.225 0 .406.181.406.406v12.688a.406.406 0 1 1-.812 0V10.874c0-.223.182-.406.406-.406Zm5.438 0c.224 0 .406.181.406.406v12.688a.406.406 0 1 1-.813 0V10.874c0-.223.183-.406.407-.406ZM12.233.5h4.532c.698 0 1.359.33 1.771.888l.002.003 1.905 2.535.15.199h5.687c.223 0 .407.184.407.406a.409.409 0 0 1-.407.407H2.72a.409.409 0 0 1-.406-.407c0-.222.183-.406.406-.406h5.687l.15-.2 1.903-2.534.002-.002A2.211 2.211 0 0 1 12.234.5Zm0 .813a1.41 1.41 0 0 0-1.12.558l-.002.002-1.09 1.451-.601.801h10.158l-.602-.8-1.09-1.452a1.405 1.405 0 0 0-1.121-.56h-4.532Z"
    }, null, -1)
  ])))
}
export default { render: render }